const DOT_SELECTOR = '.dots__dot'
const DOTS_SELECTOR = '.announcement-bar__dots'
const SLIDE_SELECTOR = '[data-announcement-slide]'

class AnnouncementBar extends HTMLElement {
  #currentIndex = 0
  #dotsContainer = null
  #events = null

  #handleDotClick = (event) => {
    if (!(event.target instanceof Element)) return

    const dot = event.target.closest(DOT_SELECTOR)
    if (!(dot && this.#dotsContainer?.contains(dot))) return

    if (dot.getAttribute('aria-controls') !== this.id) return

    this.#select(Number.parseInt(dot.dataset.index, 10))
  }

  #handleBlockSelect = (event) => {
    const index = this.items.indexOf(event.target)
    if (index >= 0) this.#select(index)
  }

  connectedCallback() {
    if (!this.items.length) return

    this.#dotsContainer = this.parentElement?.querySelector(DOTS_SELECTOR)
    this.#hideDotsWhenSingleSlide()
    this.#updateSlides()
    this.#setupEvents()
  }

  disconnectedCallback() {
    this.#events?.abort()
    this.#events = null
    this.#dotsContainer = null
  }

  get items() {
    return Array.from(this.querySelectorAll(SLIDE_SELECTOR))
  }

  get dots() {
    if (!this.#dotsContainer) return []

    return Array.from(
      this.#dotsContainer.querySelectorAll(DOT_SELECTOR)
    ).filter((dot) => dot.getAttribute('aria-controls') === this.id)
  }

  #setupEvents() {
    this.#events?.abort()
    this.#events = new AbortController()
    const { signal } = this.#events

    this.#dotsContainer?.addEventListener('click', this.#handleDotClick, {
      signal
    })
    if (globalThis.Shopify?.designMode) {
      this.addEventListener('shopify:block:select', this.#handleBlockSelect, {
        signal
      })
    }
  }

  #hideDotsWhenSingleSlide() {
    if (!this.#dotsContainer) return

    this.#dotsContainer.hidden = this.items.length <= 1
  }

  #select(index) {
    if (!(Number.isInteger(index) && this.items[index])) return

    this.#currentIndex = index
    this.#updateSlides()
  }

  #updateSlides() {
    this.items.forEach((item, index) => {
      const isCurrent = index === this.#currentIndex
      item.classList.toggle('is-active', isCurrent)
      if (isCurrent) {
        item.removeAttribute('aria-hidden')
      } else {
        item.setAttribute('aria-hidden', 'true')
      }
    })

    this.dots.forEach((dot, index) => {
      dot.setAttribute('aria-current', String(index === this.#currentIndex))
    })
  }
}

if (!customElements.get('announcement-bar')) {
  customElements.define('announcement-bar', AnnouncementBar)
}
